import React, { Component } from 'react';
import PanelView from '../model/PanelView.js';
import moment from 'moment';
import {clone, push, remove} from '../util/Utility.js';
import {CCOButton, CCOAlert} from '../util/Components';

export default class ApproveUserPanelView extends Component {

  constructor(props) {
    super(props);

    this.defaultState = {
      object: null,
    };

    this.state = {
      object: clone(props.objectPass),
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps != this.props) {
      this.state = clone(this.defaultState);
      this.setState({object: clone(newProps.objectPass)});
    }
  }

  approveClicked() {
    push('approved_users', this, {email: this.state.object.email}).then(() => {
      this.declineClicked();
    });
  }

  declineClicked() {
    remove('pending_users/' + this.state.object.key).catch(() => this.setState({networkAlert: true}));
  }

  render() {

    var object = this.state.object;

    return (
      <PanelView type="user_approval" setState={this.setState.bind(this)} object={object} {...this.props}>
        <center>
          <h2 style={{margin: 0}}>{object.email}</h2>
          <div style={{height: 5}} />
          <p>Asked for approval on {moment.unix(object.date).format("dddd, MMMM Do YYYY")}</p>
          <div style={{width: 200}}>
            <CCOButton onClick={this.approveClicked.bind(this)} type="primary" text="Approve" />
            <div style={{height: 10}} />
            <CCOButton onClick={this.declineClicked.bind(this)} type="destructive" text="Decline" />
          </div>
        </center>

        <CCOAlert in={this.state.networkAlert} type="warning" title="Network Error" content="Could not save because we could not connect to the server, please try again later." />

      </PanelView>
    );

  }
}



/** WEBPACK FOOTER **
 ** ./src/approvals/ApproveUserPanelView.js
 **/